import { Fragment, useState } from "react";

const Footer_Modal_videobox = () => {
    const [showPopup, setShowPopup] = useState(false);

    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    return (
        <Fragment>

            <button onClick={togglePopup} className="fixed bottom-[7px] bg-[#24bdeb] p-[14px] rounded-[100%] right-[10px] w-[93px] h-[90px] text-[white]" style={{"border":"solid 4px #e6e7e7ba","zIndex":"9999"}}>بازارانو چیست؟</button>


            {showPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-4 relative w-full max-w-3xl">
                        <button
                            onClick={togglePopup}
                            className="absolute -top-2 right-2  hover:text-gray-900 text-xl focus:outline-none bg-[#FF9800] w-[33px] rounded-[100%] h-[32px] text-[white]"
                        >
                            &times;
                        </button>


                        <div className="relative pb-[57%] h-0">
                            <iframe
                                className="absolute top-0 left-0 w-full h-full"
                                src="https://www.aparat.com/video/video/embed/videohash/ayx0ub6/vt/frame"
                                allowFullScreen={true}
                                webkitAllowFullScreen={true}
                                mozAllowFullScreen={true}
                                frameBorder="0"
                                title="Aparat Video"
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default Footer_Modal_videobox;
